import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-center"
}
const _hoisted_2 = {
  key: 2,
  class: "text-center"
}
const _hoisted_3 = {
  key: 5,
  class: "text-center"
}
const _hoisted_4 = {
  key: 6,
  class: "text-center"
}
const _hoisted_5 = {
  key: 10,
  class: "flex justify-start"
}
const _hoisted_6 = {
  key: 12,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_containers_cargo_status = _resolveComponent("containers-cargo-status")!

  return (['invoiceNumber', 'title'].includes(_ctx.column.key))
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        class: "text-blue-500 text-center",
        to: `/invoice/${_ctx.row.id}`,
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.row.invoiceNumber), 1)
        ]),
        _: 1
      }, 8, ["to"]))
    : (_ctx.column.key === 'stopsCount')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.row[_ctx.column.key] || 0), 1))
      : (_ctx.column.key === 'weight')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.row[_ctx.column.key] || 0), 1))
        : (_ctx.column.key === 'statusId')
          ? (_openBlock(), _createElementBlock("i", {
              key: 3,
              class: _normalizeClass(_ctx.getCheckOrTimesIcon(_ctx.row.statusId === 1))
            }, null, 2))
          : (_ctx.column.key === 'shipmentType')
            ? (_openBlock(), _createElementBlock("i", {
                key: 4,
                class: _normalizeClass(_ctx.getShipmentIcon(_ctx.row.shipmentType))
              }, null, 2))
            : (_ctx.column.key === 'volumeWeight')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.row[_ctx.column.key] || 0), 1))
              : (_ctx.column.key === 'places')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.row[_ctx.column.key] || 0), 1))
                : (_ctx.column.key === 'problems')
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 7 }, _renderList(_ctx.row.problems, (pb, i) => {
                      return (_openBlock(), _createBlock(_component_cheap, {
                        key: `pb-${i}`,
                        class: "w-max small mb-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(pb), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : (_ctx.column.key === 'createdAt')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                        _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.createdAt)), 1)
                      ], 64))
                    : (_ctx.column.key === 'deliveryDate')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.deliveryDate)), 1)
                        ], 64))
                      : (_ctx.column.key === 'deliveryStatus' && _ctx.row.deliveryStatus)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_ctx.row.deliveryStatus)
                              ? (_openBlock(), _createBlock(_component_containers_cargo_status, {
                                  key: 0,
                                  status: _ctx.row.deliveryStatus
                                }, null, 8, ["status"]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_ctx.column.key === 'timer')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 11,
                              class: _normalizeClass(_ctx.getTimerClass)
                            }, _toDisplayString(_ctx.row.timer), 3))
                          : (_ctx.column.key === 'waitList' && _ctx.row.waitList)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.row[_ctx.column.key].name || '-'), 1))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                                _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key]), 1)
                              ], 64))
}